import { Panel, Kpi } from "@/components/common";
import { gbp, pnlClass, fmt } from "@/lib/api";

export function AccountPanel({ ledger }) {
  const l = ledger || {};
  const mt5 = l.balance_source === "mt5";
  return (
    <Panel title={mt5 ? "Account (matched to MT5)" : "Paper account"} testid="levels-account-panel">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6">
        <Kpi label="Balance" value={gbp(l.balance)} testid="account-balance-kpi" sub={mt5 ? "Live from your MT5 account" : `Start ${gbp(l.starting_balance)}`} />
        <Kpi label="Equity" value={gbp(l.equity)} testid="account-equity-kpi" sub={mt5 ? "Live from your MT5 account" : undefined} />
        <Kpi label="Open P&L" value={gbp(l.open_pnl)} className={pnlClass(l.open_pnl)} testid="account-open-pnl-kpi" />
        <Kpi label="Today P&L" value={gbp(l.today_pnl)} className={pnlClass(l.today_pnl)} testid="account-today-pnl-kpi" />
        <Kpi label="Total P&L" value={gbp(l.total_pnl)} className={pnlClass(l.total_pnl)} testid="account-total-pnl-kpi" />
        <Kpi label="Win rate" value={l.win_rate == null ? "-" : `${fmt(l.win_rate, 1)}%`} testid="account-win-rate-kpi" sub={`${l.closed_count || 0} closed trades`} />
      </div>
    </Panel>
  );
}
